import { AuditLog } from './AuditLog';
import { Bookmark } from './Bookmark';
import { Chart } from './Chart';
import { Comment } from './Comment';
import { ConnectedAccount } from './ConnectedAccount';
import { CustomFilter } from './CustomFilter';
import { Dashboard } from './Dashboard';
import { Folder } from './Folder';
import { Investment } from './Investment';
import { Member } from './Member';
import { Memo } from './Memo';
import { Pipeline } from './Pipeline';
import { Report } from './Report';
import { Role } from './Role';
import { Session } from './Session';
import { Task } from './Task';
import { Team } from './Team';
import { Watchlist } from './Watchlist';
import { Workspace } from './Workspace';

export enum UserPlan {
    INACTIVE = 'Inactive',
    FREE = 'Free',
    PLUS_MONTHLY = 'Plus - Monthly Plan',
    PLUS_ANNUALLY = 'Plus - Annual Plan',
    PRO_MONTHLY = 'Pro - Monthly Plan',
    PRO_ANNUALLY = 'Pro - Annual Plan',
    PREMIUM_MONTHLY = 'Premium - Monthly Plan',
    PREMIUM_ANNUALLY = 'Premium - Annual Plan',
    EDUCATION_MONTHLY = 'Education - Monthly Plan',
    EDUCATION_ANNUALLY = 'Education - Annual Plan',
    ENTERPRISE = 'Enterprise',
}

export enum UserAuthenticationService {
    GOOGLE = 'Google',
    MICROSOFT = 'Microsoft',
    MAGIC = 'Magic Login',
    SSO = 'SSO',
}

export interface User {
    id: string;
    firstName: string;
    lastName: string;
    emailAddress: string;
    companyName: string | null;
    companyWebsite: string | null;
    username: string | null;
    title: string | null;
    calendarLink: string | null;
    bio: string | null;
    avatar: string;
    background: string;
    emailConfirmed: boolean;
    onboardingCompleted: boolean;
    authenticationService: UserAuthenticationService | undefined;
    plan: UserPlan | undefined;
    planActive: boolean | undefined;
    activeWorkspace: Workspace;
    workspaces: Workspace[];
    activeMember: Member;
    members: Member[];
    activeRole: Role;
    roles: Role[];
    folders: Folder;
    investments: Investment[];
    comments: Comment[];
    customFilters: CustomFilter[];
    charts: Chart[];
    watchlists: Watchlist[];
    memos: Memo[];
    pipelines: Pipeline[];
    dashboards: Dashboard[];
    reports: Report[];
    tasks: Task[];
    teams: Team[];
    sessions: Session[];
    bookmarks: Bookmark[];
    auditLogs: AuditLog[];
    connectedAccounts: ConnectedAccount[];
    verificationToken: string | null | undefined;
    resetToken: string | null | undefined;
    otpEnabled: boolean | undefined;
    otpCode: string | null | undefined;
    stripeId: string | undefined;
    timeZone: string | undefined;
    notifications: string[] | undefined;
    lastLogin: Date | undefined;
    createdAt: Date;
    updatedAt: Date;
}
